import React from "react";
import {useIntl} from "react-intl";
import {Bell, BellOff} from "lucide-react";

export function supportRequestState(session, contactId, attribution, supportNeeds) {
    const created = attribution?.get(session.id)?.[0] || null
    if (created) return {kind: "created", need: created}
    const existsForPair = supportNeeds?.some(sn => sn.contact === contactId && sn.survey === session.survey)
    if (existsForPair) return {kind: null, need: null}
    if (session.llmanalysis?.support_request_suggested) return {kind: "suggested", need: null}
    return {kind: null, need: null}
}

export default function SupportRequestPill({session, contactId, attribution, supportNeeds}) {
    const intl = useIntl()
    const {kind, need} = supportRequestState(session, contactId, attribution, supportNeeds)
    if (!kind) return null

    const cls = `support-pill ${kind}`

    if (kind === "created") {
        const category = need.category
            ? intl.formatMessage({id: `topic.${need.category}`, defaultMessage: need.category})
            : null
        const role = need.supporttype
            ? intl.formatMessage({id: `role.${need.supporttype}`, defaultMessage: need.supporttype})
            : null
        const target = [category, role].filter(Boolean).join(" → ")
        // The role is next to the topic tags; fallback to the category, then a generic label when neither is set.
        const label = role || category || intl.formatMessage({id: "analysis.supportRequest.label", defaultMessage: "Support request"})
        const title = target
            ? intl.formatMessage({id: "analysis.supportRequest.createdTitleTarget", defaultMessage: "Support request created · {target}"}, {target})
            : intl.formatMessage({id: "analysis.supportRequest.createdTitle", defaultMessage: "Support request created"})
        return <span className={cls} title={title}>
            <Bell size={11} />
            {label}
        </span>
    }

    // Suggested but not created — the actionable drop-off.
    const title = intl.formatMessage({id: "analysis.supportRequest.suggestedTitle", defaultMessage: "Support request suggested, but none was created"})
    return <span className={cls} title={title}>
        <BellOff size={11} />
        {intl.formatMessage({id: "analysis.funnel.notCreated", defaultMessage: "Not created"})}
    </span>
}
